import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <h2 className="section-title">{contactData.title}</h2>
        <p className="section-subtitle">{contactData.description}</p>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-lg text-primary-600"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-500">电子邮箱</p>
                  <p className="text-sm font-medium text-foreground-950">{contactData.email}</p>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-wechat-line text-lg text-accent-600"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-500">微信公众号</p>
                  <p className="text-sm font-medium text-foreground-950">{contactData.wechat}</p>
                </div>
              </div>
            </div>

            <div className="mt-8 p-5 bg-background-100 rounded-lg">
              <h3 className="text-sm font-heading text-foreground-950 mb-3">联系提示</h3>
              <ul className="space-y-2.5">
                {contactData.tips.map((tip) => (
                  <li key={tip} className="flex items-start gap-2 text-sm text-foreground-600">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-information-line text-primary-500"></i>
                    </div>
                    {tip}
                  </li>
                ))}
              </ul>
            </div>

            <a
              href={`mailto:${contactData.email}`}
              className="inline-flex items-center gap-2 mt-6 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer w-full sm:w-auto justify-center"
            >
              <i className="ri-send-plane-line"></i>
              发送反馈
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}